import { render } from "./BigHitPositionModal.vue?vue&type=template&id=4e61c83c&scoped=true&ts=true"
import script from "./BigHitPositionModal.vue?vue&type=script&lang=ts"
export * from "./BigHitPositionModal.vue?vue&type=script&lang=ts"

import "./BigHitPositionModal.vue?vue&type=style&index=0&id=4e61c83c&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e61c83c"]])

export default __exports__